import React, { useId } from 'react';
import { tx } from './i18n';

// Product-photo references and family/model distinctions:
// docs/laboratory-instrument-illustrations.md. Artwork never defines inventory.
function MaxwellRsc({ paint }) {
  return <>
    <ellipse cx="112" cy="157" rx="66" ry="4" fill={paint('shadow')} stroke="none" />
    <path d="M61 148v7h12v-7m74 0v7h12v-7" fill="#354357" />
    <path d="M61 24h89q7 0 9 8l8 27 3 92H52l3-92Z" fill={paint('metal')} />
    <path d="m150 24 9 8 8 27 3 92h-7l-3-92Z" fill={paint('side')} stroke="#8996a7" />
    <path d="M61 24h89l10 35H55q0-15 6-35Z" fill={paint('shell')} />
    <path d="M55 59h105l2 38H54Z" fill={paint('glass')} />
    <path d="M62 66h91v5H62Z" fill="#63738a" stroke="none" />
    <path d="M65 74h85v5H65Z" fill="#16263e" stroke="none" />
    {[69, 79, 89, 99, 109, 119, 129, 139].map(x => <g key={x}>
      <path d={`M${x} 79v12h5V79`} fill="#9eafbf" stroke="#55677e" strokeWidth=".6" />
      <path d={`M${x + 2.5} 71v4`} stroke="#d5dfeb" />
    </g>)}
    <path d="m59 63-1 29m5-29-1 22" stroke="#e3ecf4" opacity=".35" />
    <path d="M54 98h108l1 52H52Z" fill={paint('metal')} />
    <path d="M53 141h51c19 0 21-10 39-10h20v19H52Z" fill="#344960" stroke="none" />
    <path d="M62 108h23m-23 3h13" stroke="#627388" strokeWidth="1.4" />
    <path d="M128 140h26m-18 3h18" stroke="#dbe4ef" strokeWidth="1.1" />
    <path d="M55 97h107" stroke="#aab5c3" strokeWidth="2" />
  </>;
}

function Qiasymphony({ paint }) {
  return <>
    <ellipse cx="111" cy="156" rx="98" ry="4" fill={paint('shadow')} stroke="none" />
    <path d="M22 145v10h9v-10m150 0v10h9v-10" fill="#354357" />
    <path d="m24 28 145-4 24 14v109l-23 6H21V42q0-9 3-14Z" fill={paint('shell')} />
    <path d="m169 24 24 14v109l-23 6V42Z" fill={paint('side')} />
    <path d="m174 36 12 8v56l-12-5Z" fill={paint('glassLight')} />
    <path d="M29 32h135v69H29Z" fill={paint('glassLight')} />
    <path d="M37 40h121v5H37Z" fill="#73849c" stroke="none" />
    <path d="M42 45v45m106-45v45" stroke="#a8b6c8" strokeWidth="3" />
    <path d="M112 44h23v29h-23Z" fill={paint('metal')} />
    {[116, 122, 128].map(x => <path key={x} d={`M${x} 74v11`} strokeWidth="1.3" />)}
    <path d="M36 87h119l7 12H30Z" fill="#bac8d8" stroke="none" />
    {[88, 103, 118, 133].map(x => <path key={x} d={`M${x} 85h10v9h-10Z`} fill="#e8eef5" stroke="#899bb1" strokeWidth=".6" />)}
    <path d="m32 34 24 0-24 50Z" fill="white" opacity=".35" stroke="none" />
    <path d="M23 42q0-10 6-13v121h-7Z" fill="#346a91" stroke="none" />
    <path d="M164 28h6v125h-6Z" fill="#346a91" stroke="none" />
    <path d="M30 101h134v5H30Z" fill="#4587b6" stroke="none" />
    <path d="M32 103h130" stroke="#9dbfd9" strokeDasharray="2 4" />
    <path d="M29 107h135v43H29Z" fill={paint('metal')} />
    <path d="M53 107v43m57-43v43m26-43v43M29 119h135m-135 10h135" stroke="#a4b0bf" strokeWidth=".8" />
    <path d="m30 121 0 5h23m1-5v5h55m2-5v5h24m2-5v5h26" stroke="#8a99ad" strokeWidth="1.2" />
    <path d="M35 67q0-3 3-3h40q3 0 3 3v29H35Z" fill={paint('metal')} />
    <path d="M40 69h36v22H40Z" fill="#263d59" stroke="none" />
    <path d="M44 73h28v3H44Z" fill="#dde8f1" stroke="none" />
    <path d="M44 80h17m-17 4h23" stroke="#92b2ce" strokeWidth="1.2" />
    <circle cx="25" cy="139" r="1.4" fill="#203951" stroke="none" />
  </>;
}

function Qubit({ paint }) {
  return <>
    <ellipse cx="112" cy="155" rx="56" ry="4" fill={paint('shadow')} stroke="none" />
    <path d="M76 24q33-8 66 0 10 2 13 15l8 94q1 15-15 18-34 7-69-1-13-3-13-16l-2-81q0-22 12-29Z" fill={paint('side')} />
    <path d="M75 22q32-7 65 0 12 2 14 18l3 86q1 15-13 18-33 7-65-1-13-3-13-16V44q0-18 9-22Z" fill={paint('shell')} />
    <path d="M86 24q24-4 46 0 5 1 6 6l2 16q0 5-5 5H84q-5-1-4-6l2-15q0-5 4-6Z" fill={paint('metal')} stroke="#98a4b2" />
    <path d="M82 44q28-4 57 0" stroke="#7a879a" />
    <path d="M83 57h54q10 0 11 10l2 58q0 11-11 12l-54-1q-11-1-11-12V67q0-10 9-10Z" fill="#27354a" stroke="#657285" />
    <path d="M82 66h58v58H82Z" fill={paint('screen')} stroke="none" />
    <path d="M87 71h26m-26 4h16" stroke="#c7d8e8" strokeWidth="1" />
    {[0, 1, 2, 3, 4, 5].map(i => <g key={i} transform={`translate(${87 + i % 3 * 17} ${81 + Math.floor(i / 3) * 18})`}>
      <rect width="13" height="13" rx="1.5" fill={i < 3 ? '#4f86b3' : '#44759f'} stroke="none" />
      <path d="m4 8 5-4M4 4l5 5" stroke="#e0eaf3" strokeWidth=".9" />
    </g>)}
    <path d="M87 118h6m12 0h6m12 0h6" stroke="#aec4d9" />
    <path d="M81 56h5" stroke="#7daacb" strokeWidth="1.8" />
    <path d="M101 130h19" stroke="#8091a7" strokeWidth=".8" />
    <path d="m70 126 1-77" stroke="white" strokeWidth="2" opacity=".75" />
  </>;
}

function Hamilton({ paint }) {
  return <>
    <ellipse cx="110" cy="156" rx="103" ry="4" fill={paint('shadow')} stroke="none" />
    <path d="M22 147v7h11v-7m154 0v7h11v-7" fill="#27384d" />
    <rect x="12" y="37" width="196" height="113" rx="7" fill={paint('metal')} />
    <rect x="18" y="41" width="184" height="105" rx="3" fill="#283b57" stroke="#526783" />
    <path d="M25 65h170v69H25Z" fill={paint('glassLight')} />
    <path d="M29 70h161v4H29Z" fill="#71869e" stroke="none" />
    <path d="M31 75v51m157-51v51" stroke="#8b9cb0" strokeWidth="2.5" />
    <path d="M77 65h21v25H77Z" fill="#5e718a" />
    <path d="M74 87h29v14H74Z" fill={paint('metal')} />
    {[79, 85, 91, 97].map(x => <g key={x}>
      <path d={`M${x} 98v12`} stroke="#d1dce6" strokeWidth="2" />
      <path d={`M${x} 110v6`} stroke="#334962" strokeWidth="1.1" />
    </g>)}
    <path d="m34 117 149 0 11 17H25Z" fill={paint('metal')} />
    {[39, 54, 69, 84, 99, 114, 129, 144, 159, 174].map(x => <path key={x} d={`M${x} 119l-5 13`} stroke="#70839b" strokeWidth=".65" />)}
    {[40, 110, 140].map(x => <g key={x}>
      <path d={`M${x} 118h21l3 9h-26Z`} fill="#94a9bf" stroke="#6d819a" strokeWidth=".6" />
      <path d={`M${x + 3} 121h16m-15 3h15`} stroke="#dce7ef" strokeWidth="1.6" strokeDasharray="1 2" />
    </g>)}
    <path d="M165 110h20v15h-20Z" fill={paint('metal')} stroke="#758aa1" />
    <path d="M168 114h5v7h-5Z" fill="#52759b" stroke="none" />
    <path d="M23 82h174v3H23Zm0 25h174v4H23Z" fill="#263b57" stroke="none" />
    <path d="M30 109h129" stroke="#c4d1df" strokeWidth=".8" strokeDasharray="1 4" />
    <path d="m29 69 32 0-32 52Z" fill="white" stroke="none" opacity=".14" />
    <path d="M25 134h170l-6 8H31Z" fill={paint('metal')} stroke="none" />
    <path d="M27 58h166" stroke="#8ba0bb" strokeWidth="1.4" />
    <path d="M28 48h23m109 1h31" stroke="#e0e7ef" strokeWidth="1.8" />
    <circle cx="21" cy="119" r="1.2" fill="#8aa5bd" stroke="none" />
  </>;
}

function NovaSeq6000({ paint }) {
  return <>
    <ellipse cx="111" cy="157" rx="48" ry="3.5" fill={paint('shadow')} stroke="none" />
    <path d="M78 148v6h9v-6m48 0v6h9v-6" fill="#334258" />
    <path d="M73 43h68l8 5v102H73Z" fill={paint('metal')} />
    <path d="m141 43 8 5v102h-8Z" fill={paint('side')} />
    <path d="M73 43h68v28H73Z" fill={paint('shell')} />
    <rect x="82" y="17" width="53" height="35" rx="2.5" fill={paint('metal')} stroke="#8d9aab" />
    <path d="M85 20h47v28H85Z" fill="#edf3f8" stroke="none" />
    <path d="M85 20h47v3H85Z" fill="#5a769a" stroke="none" />
    <path d="M89 27h12v16H89Z" fill="#bacbdc" stroke="none" />
    <path d="M93 29h4v10h-4Z" fill="#748aa3" stroke="none" />
    <path d="M106 28h20m-20 5h13m-13 5h17m-17 5h10" stroke="#a9bcd0" strokeWidth="1" />
    <path d="M72 69h70v7H72Z" fill={paint('side')} />
    <path d="M73 77h69v4H73Z" fill="#83aadd" stroke="none" />
    <path d="M73 83h69v7H73Z" fill={paint('shell')} />
    <path d="M73 90h69v4H73Z" fill="#344860" stroke="none" />
    <path d="M73 96h69v54H73Z" fill={paint('metal')} />
    <path d="M107 96v54M77 99h61" stroke="#adb8c5" strokeWidth=".8" />
    <path d="M102 99h10" stroke="#7e8d9f" />
    <path d="M74 148h67v3H74Z" fill="#52647a" stroke="none" />
    <path d="M129 86h8" stroke="#a7b1be" strokeWidth=".8" />
  </>;
}

function NovaSeqX({ paint }) {
  return <>
    <ellipse cx="110" cy="157" rx="49" ry="3.5" fill={paint('shadow')} stroke="none" />
    <path d="M72 20q0-5 6-6h66l6 4v131q-1 7-8 7H81q-9 0-9-7Z" fill={paint('metal')} />
    <path d="m144 14 6 4v131q0 6-6 7V14Z" fill={paint('side')} stroke="#a4afbd" />
    <path d="M78 15v59m60-59v59" stroke="#a6b2c1" strokeWidth=".8" />
    <path d="M73 74h72v7H73Z" fill={paint('metal')} />
    <path d="M74 82h70v67q-1 4-7 4H80q-6 0-6-4Z" fill={paint('metal')} stroke="#a4b0bf" />
    <rect x="94" y="89" width="28" height="59" rx="14" fill="#d7daee" stroke="none" />
    <rect x="97" y="92" width="22" height="53" rx="11" fill={paint('light')} stroke="none" />
    <path d="M108 82v71" stroke="#9ba9bf" strokeWidth=".65" />
    <rect x="104" y="84" width="8" height="2" rx="1" stroke="#a4afbd" strokeWidth=".5" />
    <rect x="81" y="25" width="55" height="36" rx="2.5" fill="#c8d0da" stroke="#a0aebf" />
    <path d="M84 28h49v30H84Z" fill="#f4f6fb" stroke="none" />
    <path d="M94 34h28" stroke="#c1cbda" strokeWidth=".7" />
    <path d="M92 41h7m-6 4h6m5-4h7m-6 4h6m5-4h7m-6 4h6" stroke="#98a4d0" strokeWidth="1" />
    <path d="M99 51h19m-13 3h7" stroke="#b5bfd3" strokeWidth=".7" />
    <path d="M102 66h14" stroke="#a3afbd" strokeWidth=".8" />
    <path d="M77 149q0 4 5 4h54" stroke="#f1f4f8" strokeWidth="1.3" />
  </>;
}

const INSTRUMENTS = {
  maxwell_rsc: MaxwellRsc,
  qiasymphony: Qiasymphony,
  qubit: Qubit,
  hamilton: Hamilton,
  novaseq_6000: NovaSeq6000,
  novaseq_x_series: NovaSeqX,
};

export function LabInstrument({ code }) {
  const id = useId();
  const paint = name => `url(#${id}-${name})`;
  if (!Object.hasOwn(INSTRUMENTS, code)) return <span className="xo-lab-instrument-unavailable">{tx('ui.lab.visual.illustration_pending')}</span>;
  const Instrument = INSTRUMENTS[code];
  return <svg className="xo-lab-instrument" data-instrument={code} viewBox="0 0 220 170" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id={`${id}-shell`} x1="0" y1="0" x2=".3" y2="1"><stop stopColor="#fff" /><stop offset=".55" stopColor="#f2f5f9" /><stop offset="1" stopColor="#dfe6ee" /></linearGradient>
      <linearGradient id={`${id}-metal`}><stop stopColor="#bec9d6" /><stop offset=".12" stopColor="#e9eef4" /><stop offset=".46" stopColor="#f1f4f8" /><stop offset=".88" stopColor="#d8e0e9" /><stop offset="1" stopColor="#bbc7d5" /></linearGradient>
      <linearGradient id={`${id}-side`}><stop stopColor="#b9c6d5" /><stop offset="1" stopColor="#8c9caf" /></linearGradient>
      <linearGradient id={`${id}-glass`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="#17263b" /><stop offset="1" stopColor="#34485f" /></linearGradient>
      <linearGradient id={`${id}-glassLight`} x1="0" y1="0" x2="1" y2="1"><stop stopColor="#e3edf5" /><stop offset=".5" stopColor="#c4d3e2" /><stop offset="1" stopColor="#95aac2" /></linearGradient>
      <linearGradient id={`${id}-screen`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="#1b2c47" /><stop offset="1" stopColor="#274970" /></linearGradient>
      <linearGradient id={`${id}-light`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="#b3cef0" /><stop offset="1" stopColor="#aaa7dc" /></linearGradient>
      <radialGradient id={`${id}-shadow`}><stop stopColor="#7a8ca5" stopOpacity=".25" /><stop offset="1" stopColor="#7a8ca5" stopOpacity="0" /></radialGradient>
    </defs>
    <g stroke="#6e7f95" strokeWidth=".95" strokeLinejoin="round" strokeLinecap="round"><Instrument paint={paint} /></g>
  </svg>;
}
